import { DateRange } from "../Model/Date";

// const minDate = new Date("0001-01-01T00:00:00Z");

class DateUtil {
  static dateDiffInDays(first: Date, second: Date) {
    return Math.abs(
      Math.round((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24))
    );
  }

  static getMonthYearName(date: Date) {
    const shortMonthName = date.toLocaleString("en-US", { month: "long" });
    return shortMonthName + " " + date.getFullYear();
  }

  static getCurrentYear() {
    const date = new Date();
    return date.getFullYear();
  }

  static getCurrentMonth() {
    const date = new Date();
    return date.getMonth();
  }

  static isInRange(dateRange: DateRange, date: Date) {
    return date >= dateRange.start && date <= dateRange.end;
  }
  static isSameMonth(d1: Date, d2: Date) {
    return (
      d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth()
    );
  }
  static isSameDay(d1: Date, d2: Date) {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  static isToday(date: Date) {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  }

  static toDate(dateString: string) {
    return new Date(dateString);
  }

  static getDayName(date: Date) {
    if (DateUtil.isToday(date)) {
      return "Today";
    }
    return date.toLocaleDateString("en-US", { weekday: "long" });
  }

  static toString(date: Date): string {
    const year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    month = month.length < 2 ? "0" + month : month;
    let day = date.getDate().toString();
    day = day.length < 2 ? "0" + day : day;
    return year + "-" + month + "-" + day;
  }

  static isMinDate(date: Date): boolean {
    const equal = date.getFullYear() === 1;
    return equal;
  }

  static pad(n: number) {
    return n < 10 ? "0" + n : n;
  }

  static convertMinutesToHHMMSS(n: number) {
    return new Date(n * 60000).toISOString().substr(11, 8);
  }

  static toUsDateOnlyFormatString(date: Date): string {
    //https://www.101computing.net/time-conversion-algorithm/
    const year = date.getFullYear();
    const month = DateUtil.pad(date.getMonth() + 1).toString();
    const day = DateUtil.pad(date.getDate()).toString();

    return `${month}/${day}/${year}`;
  }

  static toUsFormatString(date: Date): string {
    //https://www.101computing.net/time-conversion-algorithm/
    const year = date.getFullYear();
    const month = DateUtil.pad(date.getMonth() + 1).toString();
    const day = DateUtil.pad(date.getDate()).toString();
    let hour = date.getHours();
    const minutes = DateUtil.pad(date.getMinutes());
    const ampm = hour < 12 ? "AM" : "PM";
    hour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    const hourString = DateUtil.pad(hour);
    //remove the second as it makes the string to long. If we need to add seconds, create new method.
    return `${month}/${day}/${year} ${hourString}:${minutes} ${ampm}`;
  }

  static isLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  static isValidDate(day: number, month: number, year: number) {
    const maxDayPerMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 2) {
      if (this.isLeapYear(year))
        if (day > 0 && day < 30) return true;
        else if (day > 0 && day <= maxDayPerMonth[month - 1]) return true;
    } else if (month === 1 || (month > 2 && month <= 12)) {
      if (day > 0 && day <= maxDayPerMonth[month - 1]) return true;
    }
    return false;
  }

  // validate string date using format yyyy-mm-dd
  static isValidDateString(dateString: string) {
    // eslint-disable-next-line
    const dateRex = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    const result = dateString.match(dateRex);
    if (result) return true;
    else return false;
  }

  // Result day, month, year in array
  // empty array if not possible
  static parseDateString(dateString: string) {
    const result = [];

    if (this.isValidDateString(dateString)) {
      const pdate = dateString.split("-");
      const year = parseInt(pdate[0]);
      const month = parseInt(pdate[1]);
      const day = parseInt(pdate[2]);
      result.push(day);
      result.push(month);
      result.push(year);
    }

    return result;
  }

  static getCurrentDateString(): string {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let monthStr = month < 10 ? "0" + month : month;
    let day = today.getDate();
    let dayStr = day < 10 ? "0" + day : day;
    const date = year + "-" + monthStr + "-" + dayStr;
    return date;
  }
}

export default DateUtil;
